export default {"src":"/_next/static/media/carDamage_64.45294ffc.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};